import React from "react";

export default function SupportIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.74327 1.21992C10.9322 1.21811 12.1094 1.45488 13.2051 1.9162C14.3009 2.37753 15.293 3.05402 16.1226 3.90564C16.937 4.74161 17.5787 5.7298 18.0112 6.81379C18.4437 7.89777 18.6584 9.05632 18.6431 10.2233C18.6278 11.3903 18.3829 12.5428 17.9222 13.6151C17.4615 14.6874 16.7941 15.6584 15.9581 16.4728C14.5347 17.856 12.6893 18.7228 10.716 18.9353C8.74267 19.1477 6.75502 18.6935 5.06986 17.645L5.15386 17.7266L1.66681 18.976L3.01097 15.8896C1.54083 14.1747 0.778887 11.9643 0.880012 9.70769C0.981136 7.45112 1.93774 5.31773 3.55538 3.74116C5.21151 2.12784 7.43122 1.22342 9.74327 1.21992Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.9265 8.5584C6.09917 4.86129 12.7746 3.64515 12.6566 8.35191C12.5715 9.09842 12.2436 9.90321 10.4419 11.4218C9.88478 11.8967 9.55134 12.4142 9.51385 12.6562"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.37892 15.9346C9.87296 15.9346 10.2735 15.5341 10.2735 15.0401C10.2735 14.546 9.87296 14.1455 9.37892 14.1455C8.88488 14.1455 8.48438 14.546 8.48438 15.0401C8.48438 15.5341 8.88488 15.9346 9.37892 15.9346Z"
        fill="white"
      />
    </svg>
  );
}
